import React from 'react'

const ErrorText = ({children}) => {
    return (  
        <p className='validation-error-text'>{children}</p>
    );
}
 
export default ErrorText;